/**
 * Utility functions for handling PWA manifest in Angular
 */

/**
 * Gets the correct manifest URL based on environment
 */
export function getManifestUrl(): string {
  // For Angular, we don't use PUBLIC_URL, but we can support baseHref
  const baseHref = document.querySelector('base')?.getAttribute('href') || '/';
  const cleanBaseHref = baseHref.endsWith('/') ? baseHref.slice(0, -1) : baseHref;
  return `${cleanBaseHref}/manifest.webmanifest`;
}

/**
 * Validates that the manifest exists and is accessible
 */
export async function validateManifestExists(manifestUrl: string): Promise<boolean> {
  try {
    // Add cache-busting timestamp to prevent cached 404s
    const cacheBuster = `?t=${Date.now()}`;
    const urlWithCacheBuster = manifestUrl + cacheBuster;

    const response = await fetch(urlWithCacheBuster, {
      cache: 'no-cache', // Force revalidation
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate'
      }
    });

    if (!response.ok) {
      throw new Error(`Manifest not found: ${response.status}`);
    }
    return true;
  } catch (error) {
    throw error;
  }
}